export default __webpack_public_path__ + "static/media/449East-1BR.30a46e05.svg";